import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=4323fb91&scoped=true&"
import script from "./AttachmentList.vue?vue&type=script&lang=js&"
export * from "./AttachmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323fb91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
